// Utilitários para resolver cores/status de chips do Dashboard a partir de thresholds
// definidos em /report-config (dashboard.chips)

export function resolveChipColorFromThresholds(chipRules, value, fallbackColor) {
  if (!chipRules || !Array.isArray(chipRules.thresholds)) {
    return fallbackColor;
  }

  const { thresholds } = chipRules;
  if (!Array.isArray(thresholds) || thresholds.length === 0) {
    return fallbackColor;
  }

  const numericValue = Number(value);
  if (!Number.isFinite(numericValue)) {
    return fallbackColor;
  }

  for (const t of thresholds) {
    if (!t || typeof t !== 'object') continue;
    const { min, max, color } = t;
    const hasMin = typeof min === 'number';
    const hasMax = typeof max === 'number';

    if (hasMin && numericValue < min) continue;
    if (hasMax && numericValue > max) continue;

    if (typeof color === 'string' && color) {
      return color;
    }
  }

  return fallbackColor;
}

export function resolveStatusFromThresholds(chipRules, value, fallbackStatus) {
  if (!chipRules || !Array.isArray(chipRules.thresholds)) {
    return fallbackStatus;
  }

  const { thresholds } = chipRules;
  if (!Array.isArray(thresholds) || thresholds.length === 0) {
    return fallbackStatus;
  }

  const numericValue = Number(value);
  if (!Number.isFinite(numericValue)) {
    return fallbackStatus;
  }

  for (const t of thresholds) {
    if (!t || typeof t !== 'object') continue;
    const { min, max, status } = t;
    const hasMin = typeof min === 'number';
    const hasMax = typeof max === 'number';

    if (hasMin && numericValue < min) continue;
    if (hasMax && numericValue > max) continue;

    if (typeof status === 'string' && status) {
      return status;
    }
  }

  return fallbackStatus;
}
